import actionTypes from "../actionTypes";


const enqueueSnackbar = notification => {
  const key = notification.options && notification.options.key;

  return {
    type: actionTypes.notifications.ENQUEUE_SNACKBAR,
    notification: {
      ...notification,
      key: key || new Date().getTime() + Math.random()
    }
  };
}

const closeSnackbar = key => {
  return {
    type: actionTypes.notifications.CLOSE_SNACKBAR,
    dismissAll: !key, // dismiss all if no key is defined
    key: key
  };
}

const removeSnackbar = key => {
  return {
    type: actionTypes.notifications.REMOVE_SNACKBAR,
    key
  };
}

export const notificationActions = {
  enqueueSnackbar,
  closeSnackbar,
  removeSnackbar
};